"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_DE_TRANS = {
    'time picker': 'Zeit wählen',
    'today': 'Heute',
    'set time': 'Zeit festlegen',
    'close': 'Schließen',
    'confirm': 'Bestätigen',
    'hour': 'Stunde',
    'minute': 'Minute',
    'second': 'Sekunde',
};
//# sourceMappingURL=de.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/de.js
// module id = ../../../../ng2-date-time-picker/locale/de.js
// module chunks = 4